import {useEffect} from 'react';

export function useLogoutSync(logoutUri = '/logout.html'): void {
  useEffect(() => {
    const channel = new BroadcastChannel('qii:logout');
    channel.onmessage = () => {
      localStorage.clear();
      window.location.replace(logoutUri);
    };
    return () => {
      channel.close();
    };
  }, [logoutUri]);
}
